import { motion } from 'framer-motion';
import { Outlet, useParams } from 'react-router-dom';

import { SpaceDiscriminator } from '@client/api';
import { PageDetailContent } from '@client/toolkit';

import { InvestmentsCard } from '../../../components/investments-card/investments-card.component';

export function SpaceInvestmentsRoute() {
  const { spaceId } = useParams<{ buildingId: string; spaceId: string, discriminator: SpaceDiscriminator }>();

  return (
    <>
      <PageDetailContent align="left">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            opacity: { ease: 'linear', duration: 0.2 },
            y: { ease: 'easeInOut', duration: 0.4 },
          }}
        >
          <InvestmentsCard spaceId={spaceId} />
        </motion.div>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
